import { Component, OnDestroy, computed } from '@angular/core';
import { IReportsState } from '../store/reports/state';
import { IAppAuthorizations, IUiAuthorizations } from '../authorizations/state';
import { getRelaxedUiAuth } from 'src/app/authorizations/selector';
import { Lux } from '@roosevelt/common-ui-lib/core';
import { toSignal } from '@angular/core/rxjs-interop';

@Component({
    selector: 'app-reports',
    template: '<app-reports-view [reportFeatures]="reportFeatures()"></app-reports-view>',
    standalone: false
})
export class ReportsContainer implements OnDestroy {
  luxId = 'BMT-Reports-Component' + this.constructor.name;
  relaxedAuth = toSignal(this.lux.get(getRelaxedUiAuth, this.luxId), { initialValue: {} as IUiAuthorizations | {} });
  readonly reportFeatures = computed(() => (this.relaxedAuth() as IUiAuthorizations)?.reports || []);

  constructor(private readonly lux: Lux<{ reportsState: IReportsState, appUiAuth: IAppAuthorizations }>) {}

  ngOnDestroy(): void {
    this.lux.destroy(this.luxId);
  }

}
